import React from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';
import { Event } from '@ifeng/ui_base';

class BookRecommendSlide extends React.PureComponent {
    static propTypes = {
        bookRecommendData: PropTypes.array,
        // ad: PropTypes.object,
    };

    state = {
        data: this.props.bookRecommendData,
    };

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                if (item >= 0 && item <= 4) {
                    const ref = React.createRef();
                    const ref1 = React.createRef();

                    refs.push({ index: item, ref, ref1 });

                    infoData.splice(item, 1, { type: 'ad', ref, ref1 });
                } else {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                }
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        if (ref.ref1) {
                            dom[ref.index] = [ref.ref.current, ref.ref1.current];
                        } else {
                            dom[ref.index] = ref.ref.current;
                        }
                    }

                    try {
                        adFn(dom);
                    } catch (e) {
                        console.error(e);

                        this.setState({
                            data,
                        });
                    }
                },
            );
        }

        return;
    };

    // async componentDidMount() {
    //     // 插入软广
    //     try {
    //         const { ad } = this.props;

    //         const callback = await handleAd(ad);

    //         callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
    //     } catch (e) {
    //         console.error(e);
    //     }

    //     try {
    //         const data = this.props.bookRecommendData;

    //         if (data) {
    //             this.setState(
    //                 {
    //                     data,
    //                 },
    //                 () => {
    //                     this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
    //                 },
    //             );
    //         }
    //     } catch (e) {
    //         console.error(e);
    //     }
    // }

    adInit = data => {
        try {
            this.event.trigger('init', { data }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    sliderTmpl = (list, isClone) => {
        return (
            <div className={styles.slideItem}>
                {list && list.length > 0
                    ? list.map((item, index) => {
                          if (item.type === 'ad') {
                              return (
                                  <a
                                      key="ad_key"
                                      href={item.url}
                                      className={styles.link}
                                      imgindex={index}
                                      ref={isClone ? item.ref1 : item.ref}
                                  />
                              );
                          } else {
                              return (
                                  <a
                                      key={index}
                                      href={item.url}
                                      className={styles.link}
                                      imgindex={index}
                                      title={item.title}>
                                      <img src={item.thumbnail} className={styles.imgs} />
                                      <div className={styles.title} title={item.title}>
                                          {item.title}
                                      </div>
                                  </a>
                              );
                          }
                      })
                    : ''}
            </div>
        );
    };

    render() {
        let { data } = this.state;

        if (!(data instanceof Array)) {
            data = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        const newList = [data.slice(0, 5), data.slice(5, 10), data.slice(10)];
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: this.sliderTmpl,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
        };

        return (
            <Chip id="75149" type="recommend" title="热重磅精品" groupName="正文" content={data}>
                <div className={styles.container}>
                    <div className={styles.tit}>重磅精品</div>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            </Chip>
        );
    }
}

export default errorBoundary(BookRecommendSlide);
